import { csx } from '@vtex/admin-ui'

export const wrapper = csx({
  '.ant-tree-treenode': {
    alignItems: 'center',

    '.ant-tree-checkbox': {
      marginTop: '$space-0',
      alignSelf: 'center',
    },

    '.ant-tree-switcher': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      height: '24px',
      borderRadius: '2px',
      marginRight: '$space-1',

      svg: {
        transition: 'all .2s linear',
      },

      '&.ant-tree-switcher_open': {
        svg: {
          transform: 'rotate(90deg)',
        },
      },
    },

    '.ant-tree-checkbox-inner': {
      height: '20px',
      width: '20px',
    },
  },
})
